export default __webpack_public_path__ + "static/media/audio_50_cerillos.cc784e23.mp3";